import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useToast } from '../../../services/ToastContext';
import { Switch } from '../../../components/switch/switch';
import { useEffect, useRef, useState } from 'react';
import ConfirmationModal from '../../../components/pop-up/PopUpAlert';
import { useTranslation } from 'react-i18next';
export interface LogsProps {
  summaryData: any;
}

export function RouterSettings({ summaryData }: LogsProps) {
  const { cpeId } = useParams();
  const { t } = useTranslation();
  let [gracePeriod, setGracePeriod] = useState<boolean>(false);
  let [cyberShield, setCyberShield] = useState<boolean>(false);
  let [adBlock, setAdBlock] = useState<boolean>(false);
  const [globalAllow, setGlobalAllow] = useState<any[]>([]);
  const [globalBlocked, setGlobalBlocked] = useState<any[]>([]);
  const [currentTypedWhitelist, setCurrentTypedWhitelist] = useState<string>('');
  const [currentTypedBlocklist, setCurrentTypedBlocklist] = useState<string>('');
  const { showToastMessage } = useToast();

  const [error, setError] = useState('');
  const [errorW, setWError] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const fetchSettings = async () => {
    try {
      const data = await axios.get(`v2/op/master-operator/${cpeId}/settings`);
      setGracePeriod(data.data?.gracePeriod);
      setCyberShield(data.data?.cyberShield);
      setAdBlock(data.data?.adBlock);
    } catch (error) {
      console.error('Error fetching router settings: ', error);
    }
  };

  async function fetchWhitelistFromApi() {
    const fetchGlobalAllow = await axios.get(`v2/op/master-operator/${cpeId}/global/allowed`);
    setGlobalAllow(fetchGlobalAllow.data?.domains);
  }

  async function fetchBlacklistFromApi() {
    const fetchGlobalBlocked = await axios.get(`v2/op/master-operator/${cpeId}/global`);
    setGlobalBlocked(fetchGlobalBlocked.data?.domains);
  }

  useEffect(() => {
    fetchSettings();
    const intervalId = setInterval(fetchSettings, 900000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    fetchWhitelistFromApi();
    fetchBlacklistFromApi();
  }, [cpeId]);

  async function updateAllowDevices(allowAllDevices: boolean) {
    gracePeriod = allowAllDevices;
    let period = !gracePeriod ? 0 : 10000;
    console.log(period);
    await axios.patch(`v2/op/master-operator/2/grace-period/`, { gracePeriod: period }).then(() => {
      showToastMessage(t('cpeTabs.settings.toasts.gracePeriodUpdated'));
    });
    setGracePeriod(allowAllDevices);
  }

  async function updateShieldSettings(blackdiceShieldValue: boolean) {
    await axios.patch(`v2/op/master-operator/${cpeId}/feat?adBlock=` + adBlock + '&cyberShield=' + blackdiceShieldValue);
    setCyberShield(blackdiceShieldValue);
    // ToastMessage('success', t('menu.success'));
    showToastMessage(t('cpeTabs.settings.toasts.cyberShieldUpdated'));
  }

  async function updateAdBlockerSettings(adBlockerValue: boolean) {
    await axios.patch(`v2/op/master-operator/${cpeId}/feat?adBlock=` + adBlockerValue + '&cyberShield=' + cyberShield);
    showToastMessage(t('cpeTabs.settings.toasts.adBlockUpdated'));
    setAdBlock(adBlockerValue);
  }

  const filterValidation = (website: string) => {
    if (website.includes('.')) {
      const index0 = website.replace(/\s+/g, '').split('.').slice(-2)[0];
      const index1 = website.split('.').slice(-2)[1];
      const index0Length = index0.length;
      const index1Length = index1.length;
      if (index0Length === 0) {
        return t('cpeTabs.settings.validation.domainFirstPartEmpty');
      }
      if (index1Length >= 2) {
        return true;
      } else {
        return t('cpeTabs.settings.validation.domainInvalid');
      }
    } else {
      return t('cpeTabs.settings.validation.domainRequired');
    }
  };

  const addToWhitelistFilters = async () => {
    if (currentTypedWhitelist === '') {
      showToastMessage(t('cpeTabs.settings.toasts.allowedDomainEmpty'));
      return;
    }
    const lowercaseBlocklistFilters = globalBlocked.map((item) => item.toLowerCase());
    const lowercaseWhitelistFilters = globalAllow.map((item) => item.toLowerCase());
    const blockedDomain = lowercaseBlocklistFilters.includes(currentTypedWhitelist.toLowerCase());
    const allowedDomain = lowercaseWhitelistFilters.includes(currentTypedWhitelist.toLowerCase());

    const blockedWhiteList = lowercaseBlocklistFilters.includes(currentTypedWhitelist.toLowerCase());

    if (blockedWhiteList) {
      showToastMessage(t('cpeTabs.settings.toasts.alreadyBlocked', { domain: currentTypedWhitelist }));
      return;
    }

    if (!blockedDomain && !allowedDomain) {
      const validation = filterValidation(currentTypedWhitelist);
      if (validation == true) {
        const newWhitelist = [...globalAllow, currentTypedWhitelist];
        setGlobalAllow(newWhitelist);
        if (inputRef.current) {
          inputRef.current.value = '';
          setCurrentTypedWhitelist('');
          updateWhiteListFilters(newWhitelist);
        }
      } else {
        setWError(validation);
      }
    } else {
      showToastMessage(t('cpeTabs.settings.toasts.domainExists'));
    }
  };

  const updateWhiteListFilters = async (newWhitelist: any) => {
    const filterPayload = {
      isActive: true,
      domains: newWhitelist,
    };
    try {
      await axios.patch(`v2/op/master-operator/${cpeId}/global/allowed`, filterPayload);
      showToastMessage(t('cpeTabs.settings.toasts.updated'));
    } catch (error) {
      console.error('Error updating Whitelist filters:', error);
    }
  };

  const updateBlockListFilters = async (newBlocklist: any) => {
    const filterPayload = {
      isActive: true,
      domains: newBlocklist,
    };
    try {
      await axios.patch(`v2/op/master-operator/${cpeId}/global`, filterPayload);
      showToastMessage(t('cpeTabs.settings.toasts.updated'));
    } catch (error) {
      console.error('Error updating Blocklist filters:', error);
    }
  };

  const removeWhitelist = (filter: string) => {
    setGlobalAllow((prevWhitelist) => {
      const updatedWhitelist = prevWhitelist.filter((item) => item !== filter);
      updateWhiteListFilters(updatedWhitelist);
      setGlobalAllow((prev) => prev.filter((item) => item !== filter));
      return updatedWhitelist;
    });
  };

  const removeBlocklist = (filter: string) => {
    setGlobalBlocked((prevBlocklist) => {
      const updatedBlocklist = prevBlocklist.filter((item) => item !== filter);
      updateBlockListFilters(updatedBlocklist);
      setGlobalBlocked((prev) => prev.filter((item) => item !== filter));
      return updatedBlocklist;
    });
  };

  const addBlockedDomain = (e: string) => {
    setError('');
    setCurrentTypedBlocklist(e);
  };
  const addAllowedDomain = (e: string) => {
    setWError('');
    setCurrentTypedWhitelist(e);
  };

  const addToBlocklistFilters = () => {
    if (currentTypedBlocklist === '') {
      showToastMessage(t('cpeTabs.settings.toasts.blockedDomainEmpty'));
      return;
    }

    const lowercaseBlocklistFilters = globalBlocked.map((item) => item.toLowerCase());
    const lowercaseWhitelistFilters = globalAllow.map((item) => item.toLowerCase());
    const blockedDomainList = lowercaseWhitelistFilters.includes(currentTypedBlocklist.toLowerCase());

    if (blockedDomainList) {
      showToastMessage(t('cpeTabs.settings.toasts.alreadyAllowed', { domain: currentTypedBlocklist }));
      return;
    }

    if (!lowercaseBlocklistFilters.includes(currentTypedBlocklist.toLowerCase())) {
      const validation = filterValidation(currentTypedBlocklist);
      if (validation == true) {
        const newBlocklist = [...globalBlocked, currentTypedBlocklist];
        setGlobalBlocked(newBlocklist);
        updateBlockListFilters(newBlocklist);
        if (inputRef.current) {
          inputRef.current.value = '';
          setCurrentTypedBlocklist('');
        }
      } else {
        setError(validation);
      }
    } else {
      showToastMessage(t('cpeTabs.settings.toasts.domainExists'));
    }
  };

  const [isAgentRunning, setIsAgentRunning] = useState<boolean>(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(false);
  // Which bootloader action the confirmation modal is for; title/message are derived at render so they follow the language.
  const [confirmationAction, setConfirmationAction] = useState<'start' | 'stop' | ''>('');

  const handleStartBootloader = () => {
    setConfirmationAction('start');
    setShowConfirmationModal(true);
  };

  const handleStopBootloader = () => {
    setConfirmationAction('stop');
    setShowConfirmationModal(true);
  };

  const handleBootloaderSubmit = async () => {
    try {
      if (isAgentRunning) {
        await axios.patch(`/v2/op/master-operator/start-stop/agent?cpeId=${cpeId}&isActive=false&type=cpe`);
      } else {
        await axios.patch(`/v2/op/master-operator/start-stop/agent?cpeId=${cpeId}&isActive=true&type=cpe`);
      }
    } catch (error) {
      console.error('Error stopping bootloader agent: ', error);
    }
  };

  return (
    <>
      <section className="flex h-[80vh] w-full flex-row p-6 justify-evenly">
        <div className="flex flex-col w-[18%] h-full gap-5">
          <div className="flex flex-col h-[50%] p-4 space-y-2 flex rounded-2xl shadow-md">
            <h2>{t('cpeTabs.settings.services.title')}</h2>
            <h4 className="text-[#10182080] font-normal pt-0 mt-0">{t('cpeTabs.settings.services.description')}</h4>
            <div className="flex  flex-column">
              <b className="m-0 p-0 text-left font-medium">{t('cpeTabs.settings.services.threatProtection')}</b>
              <Switch
                isDisabled={false}
                checked={cyberShield}
                onCheckedChange={(e: any) => updateShieldSettings(e)}
                className="scale-75"
              />
            </div>
            <div className="flex  flex-column">
              <b className="m-0 p-0 text-left font-medium">{t('cpeTabs.settings.services.adBlocking')}</b>
              <Switch
                isDisabled={false}
                checked={adBlock}
                onCheckedChange={(e: any) => updateAdBlockerSettings(e)}
                className="scale-75"
              />
            </div>
            <div className="flex  flex-column">
              <b className="m-0 p-0 text-left font-medium">{t('cpeTabs.settings.services.autoApprove')}</b>
              <Switch
                isDisabled={false}
                checked={gracePeriod}
                onCheckedChange={(e: any) => updateAllowDevices(e)}
                className="scale-75"
              />
            </div>
          </div>

          <div className="flex flex-col h-[50%] p-4 space-y-10 flex rounded-md shadow-md" style={{ zIndex: '999' }}>
            <h2>{t('cpeTabs.settings.agent.title')}</h2>
            <h4 className="text-[#10182080] font-normal pt-0 mt-0">{t('cpeTabs.settings.agent.description')}</h4>

            <button
              onClick={handleStartBootloader}
              disabled={isAgentRunning === true}
              title={
                isAgentRunning === true
                  ? t('cpeTabs.settings.agent.alreadyRunning')
                  : t('cpeTabs.settings.agent.startHint')
              }
              className="bg-[#003D4C] text-white flex options justify-center text-sm py-3 items-center"
              style={{ borderRadius: '999px', outline: 'none', backgroundColor: isAgentRunning ? '#777' : '#003D4C' }}
            >
              {t('cpeTabs.settings.agent.start')}
            </button>

            <button
              onClick={handleStopBootloader}
              disabled={isAgentRunning === false}
              title={
                isAgentRunning === false
                  ? t('cpeTabs.settings.agent.alreadyStopped')
                  : t('cpeTabs.settings.agent.stopHint')
              }
              className="bg-[#003D4C] text-white flex options justify-center text-sm py-3 items-center"
              style={{ borderRadius: '999px', outline: 'none', backgroundColor: !isAgentRunning ? '#777' : '#003D4C' }}
            >
              {t('cpeTabs.settings.agent.stop')}
            </button>
          </div>
        </div>

        <div className="w-[38%] h-full p-4 rounded-md shadow-md">
          <h2>{t('cpeTabs.settings.domains.blockedTitle')}</h2>
          <h4 className="text-[#10182080] font-normal pt-0 mt-0">{t('cpeTabs.settings.domains.blockedDescription')}</h4>
          <div className="flex">
            <input
              value={currentTypedBlocklist}
              onChange={(e) => addBlockedDomain(e.target.value)}
              ref={inputRef}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  addToBlocklistFilters();
                }
              }}
              style={{
                borderRadius: '9999px',
                outline: '2px solid #003D4C',
                padding: '0 25px',
                border: '1px solid #d1d5db',
                marginRight: '15px',
                height: '10px !important',
              }}
              placeholder={t('cpeTabs.settings.domains.blockPlaceholder')}
            ></input>
            <button
              onClick={addToBlocklistFilters}
              className="bg-[#003D4C] text-white flex md:w-[4rem lg:w-[15rem] options justify-center text-sm py-1 items-center"
              style={{ borderRadius: '999px', outline: 'none' }}
            >
              {t('cpeTabs.settings.domains.addDomain')}
            </button>
          </div>
          <div className="max-h-[350px] p-5 overflow-y-auto">
            <ul className="list-none flex flex-col pt-4 pl-0" id="filter-map">
              {globalBlocked.map((filter, index) => (
                <li
                  id="list-item"
                  className="flex justify-between mt-0 ml-0 mr-0 mb-4 "
                  style={{ boxShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)', borderRadius: '999px', padding: '5px 20px' }}
                  key={'bl' + index}
                >
                  <span
                    className="font-medium cursor-pointer fonts"
                    title={filter}
                    style={{ paddingBottom: '2px', maxWidth: '125px', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '14px' }}
                  >
                    {filter}
                  </span>
                  <button className="text-[#E31C79]" style={{ fontSize: '14px' }} onClick={() => removeBlocklist(filter)}>
                    {t('cpeTabs.settings.domains.remove')}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="w-[38%] h-full p-4 rounded-md shadow-md">
          <h2>{t('cpeTabs.settings.domains.allowedTitle')}</h2>
          <h4 className="text-[#10182080] font-normal pt-0 mt-0">{t('cpeTabs.settings.domains.allowedDescription')}</h4>
          <div className="flex">
            <input
              value={currentTypedWhitelist}
              onChange={(e) => addAllowedDomain(e.target.value)}
              ref={inputRef}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  addToWhitelistFilters();
                }
              }}
              style={{
                borderRadius: '9999px',
                outline: '2px solid #003D4C',
                paddingLeft: '25px',
                border: '1px solid #d1d5db',
                marginRight: '15px',
              }}
              placeholder={t('cpeTabs.settings.domains.allowPlaceholder')}
            ></input>
            <button
              onClick={addToWhitelistFilters}
              className="bg-[#003D4C] text-white flex md:w-[4rem lg:w-[15rem] options justify-center text-sm py-1 items-center"
              style={{ borderRadius: '999px', outline: 'none' }}
            >
              {t('cpeTabs.settings.domains.addDomain')}
            </button>
          </div>
          <div className='max-h-[350px] p-5 overflow-y-auto'>
            <ul className="list-none flex flex-col pt-4 pl-0" id="filter-map">
              {globalAllow.map((filter, index) => (
                <li
                  className="flex justify-between mt-0 ml-0 mr-0 mb-4"
                  style={{ boxShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)', borderRadius: '999px', padding: '5px 20px' }}
                  id="list-item"
                  key={'wl' + index}
                >
                  <span
                    className="text-sm font-medium cursor-pointer fonts"
                    title={filter}
                    style={{ paddingBottom: '2px', maxWidth: '125px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                  >
                    {filter}
                  </span>
                  <button className="text-[#E31C79]" onClick={() => removeWhitelist(filter)}>
                    {t('cpeTabs.settings.domains.remove')}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {showConfirmationModal && (
          <ConfirmationModal
            show={showConfirmationModal}
            title={confirmationAction === 'start' ? t('cpeTabs.settings.agent.startTitle') : confirmationAction === 'stop' ? t('cpeTabs.settings.agent.stopTitle') : ''}
            description={confirmationAction === 'start' ? t('cpeTabs.settings.agent.startConfirm') : confirmationAction === 'stop' ? t('cpeTabs.settings.agent.stopConfirm') : ''}
            onCancel={() => setShowConfirmationModal(false)}
            onConfirm={() => {
              setShowConfirmationModal(false);

              if (confirmationAction === 'start') {
                showToastMessage(t('cpeTabs.settings.toasts.agentStarted'));
                setIsAgentRunning(true);
              } else if (confirmationAction === 'stop') {
                showToastMessage(t('cpeTabs.settings.toasts.agentStopped'));
                setIsAgentRunning(false);
              }

             handleBootloaderSubmit()
            }}
          />
        )}
      </section>
    </>
  );
}
